
import { createRoot } from "react-dom/client";
import './index.css';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { AppReducerProvider } from './reducerContext';
import { HoveredStateProvider } from './hoverContext';


createRoot(document.getElementById('root')!).render(<React.StrictMode>
    <AppReducerProvider>
      <HoveredStateProvider>
        <App />
      </HoveredStateProvider>
    </AppReducerProvider>
  </React.StrictMode>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
